module.exports = __webpack_public_path__ + "static/media/car-3.37713380.jpg";